export default __webpack_public_path__ + "static/media/rankpage-top3.8cf45014.svg";